import { Colors, MEDIA } from "@brg/ui";
import styled from "styled-components";

export const NotFoundPageWrapperOuter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    height: 100%;
    max-height: 100vh;
    overflow: hidden;

    @media ${MEDIA.MOBILE} {
        font-size: 108px;
        line-height: 104px;
    }
`

export const NotFoundPageWrapper = styled.div`
    width: 100%;
    margin-top: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media ${MEDIA.LAPTOP} {
        margin-top: 88px;
    }

    @media ${MEDIA.MOBILE} {
        margin-top: 0;
    }
`

export const NotFoundPageNumber = styled.div`
    user-select: none;
    font-family: Inter;
    font-size: 250px;
    font-weight: 600;
    line-height: 250px;
    letter-spacing: -0.065em;
    text-align: justified;
    color: ${p => p.theme.errorPage.notFound.number};

    @media ${MEDIA.LAPTOP} {
        font-size: 200px;
        line-height: 200px;
    }

    @media ${MEDIA.MOBILE} {
        font-size: 108px;
        line-height: 104px;
    }
`

export const NotFoundPageTitle = styled.div`
    margin: 40px 0;
    user-select: none;
    font-family: Inter;
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.errorPage.notFound.title};

     @media ${MEDIA.LAPTOP} {
        line-height: 27px;
        font-size: 23px;
    }

    @media ${MEDIA.MOBILE} {
        margin: 24px 0;
        font-size: 20px;
        line-height: 25px;
    }
`

export const NotFoundPageButtons = styled.div`
    display: flex;
    justify-content: center;
    gap: 24px;

    @media ${MEDIA.LAPTOP} {
        gap: 16px;
    }

    @media ${MEDIA.MOBILE} {
        flex-direction: column;
        > div {
            width: 100%;
        }
        gap: 8px;
    }
`

export const BackButton = styled.div`
    cursor: pointer;
    border: 1px solid ${p => p.theme.errorPage.buttons.border};
    color: ${p => p.theme.errorPage.buttons.hollowText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
`

export const MainButton = styled.div`
    cursor: pointer;
    background-color: ${p => p.theme.errorPage.buttons.bg};
    color: ${p => p.theme.errorPage.buttons.filledText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
`
import { Colors, MEDIA } from "@brg/ui";
import styled from "styled-components";

export const NotFoundPageWrapperOuter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    height: 100%;
    max-height: 100vh;
    overflow: hidden;

    @media ${MEDIA.MOBILE} {
        font-size: 108px;
        line-height: 104px;
    }
`

export const NotFoundPageWrapper = styled.div`
    width: 100%;
    margin-top: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media ${MEDIA.LAPTOP} {
        margin-top: 88px;
    }

    @media ${MEDIA.MOBILE} {
        margin-top: 0;
    }
`

export const NotFoundPageNumber = styled.div`
    user-select: none;
    font-family: Inter;
    font-size: 250px;
    font-weight: 600;
    line-height: 250px;
    letter-spacing: -0.065em;
    text-align: justified;
    color: ${p => p.theme.errorPage.notFound.number};

    @media ${MEDIA.LAPTOP} {
        font-size: 200px;
        line-height: 200px;
    }

    @media ${MEDIA.MOBILE} {
        font-size: 108px;
        line-height: 104px;
    }
`

export const NotFoundPageTitle = styled.div`
    margin: 40px 0;
    user-select: none;
    font-family: Inter;
    font-size: 30px;
    font-weight: 600;
    line-height: 40px;
    letter-spacing: -0.02em;
    text-align: center;
    color: ${p => p.theme.errorPage.notFound.title};

     @media ${MEDIA.LAPTOP} {
        line-height: 27px;
        font-size: 23px;
    }

    @media ${MEDIA.MOBILE} {
        margin: 24px 0;
        font-size: 20px;
        line-height: 25px;
    }
`

export const NotFoundPageButtons = styled.div`
    display: flex;
    justify-content: center;
    gap: 24px;

    @media ${MEDIA.LAPTOP} {
        gap: 16px;
    }

    @media ${MEDIA.MOBILE} {
        flex-direction: column;
        > div {
            width: 100%;
        }
        gap: 8px;
    }
`

export const BackButton = styled.div`
    cursor: pointer;
    border: 1px solid ${p => p.theme.errorPage.buttons.border};
    color: ${p => p.theme.errorPage.buttons.hollowText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
`

export const MainButton = styled.div`
    cursor: pointer;
    background-color: ${p => p.theme.errorPage.buttons.bg};
    color: ${p => p.theme.errorPage.buttons.filledText};
    padding: 12px 48px;

    font-family: Inter;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;
    border-radius: 3px;
`
